import { render, staticRenderFns } from "./MockExam.vue?vue&type=template&id=d9f78a4a&scoped=true&"
import script from "./MockExam.vue?vue&type=script&lang=js&"
export * from "./MockExam.vue?vue&type=script&lang=js&"
import style0 from "./MockExam.vue?vue&type=style&index=0&id=d9f78a4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9f78a4a",
  null
  
)

export default component.exports